import { promMainnet } from "config/default";
import { arbitrum, bsc, mainnet, optimism, polygon } from "wagmi/chains";
import Arbitrum from "./assets/Arbitrum.svg";
import BSCLogo from "./assets/BSC.svg";
import ETHLogo from "./assets/ETH.svg";
import Optimism from "./assets/Optimism.svg";
import Polygon from "./assets/Polygon.svg";
import PROM from "./assets/Prom.svg";

export const bridgeNetworksConfig = [
  {
    logo: <ETHLogo />,
    name: "Ethereum Mainnet",
    chainId: mainnet.id,
    nativeToken: "ETH",
    availableChainsTo: [promMainnet.id, bsc.id],
  },
  {
    logo: <PROM />,
    name: "Prom",
    chainId: promMainnet.id,
    nativeToken: "PROM",
    availableChainsTo: [
      bsc.id,
      mainnet.id,
      polygon.id,
      optimism.id,
      arbitrum.id,
    ],
  },
  {
    logo: <BSCLogo />,
    name: "BSC",
    chainId: bsc.id,
    nativeToken: "BNB",
    availableChainsTo: [mainnet.id, promMainnet.id],
  },
  {
    logo: <Optimism />,
    name: "Optimism",
    chainId: optimism.id,
    nativeToken: "ETH",
    availableChainsTo: [promMainnet.id],
  },
  {
    logo: <Arbitrum />,
    name: "Arbitrum",
    chainId: arbitrum.id,
    nativeToken: "ETH",
    availableChainsTo: [promMainnet.id],
  },
  {
    logo: <Polygon />,
    name: "Polygon",
    chainId: polygon.id,
    nativeToken: "POL",
    availableChainsTo: [promMainnet.id],
  },
];
